import { useWinController } from "./useWinController";
import { useHoldAndWinCollectionController } from "./useHoldAndWinCollectionController";

const HookImport = () => {
  useWinController();
  useHoldAndWinCollectionController();
  return null;
};

export default HookImport;
